/*
命名规范
1. 小写驼峰
2. 特殊情况可特殊处理（如 侧边栏，导航栏等直接关联key的词可以采用大写驼峰）
standard  通用标准字段
login  登录
register 注册
resetPassword 忘记密码（找回密码/密码重置)
modifyPassword 修改密码 (公共组件)
cookies cookies政策（公共组件)
slideCircus 滑块拼图验证码（公共组件)
message 消息提醒
verify 表单校验提示
placeholder 表单项描述输入字段预期值的提示信息
tagsView 图钉功能相关
exit 退出登录相关
notFind 404
settings 整体相关
role 权限相关
button 按钮
accountInfo 账号信息
baseInfo 基本信息
emailLink 邮箱链接
accountSecurity 账户安全
*/

export default {
  'standard': {
    '用户不存在': 'This account has not been registered yet. Please  registing first.',
    'no_zone_code': '(no area code)',
    'onlineService': 'Online service',
    'standardExpress': 'Standard Express',
    'economyExpress': 'Economy Express',
    'eParcel': 'E-Parcel/ E-Parcel+',
    'overseasFulfilment': 'Overseas Fulfilment',
    'warehouse': 'Warehouse',
    'pleaseAgreePolicy': 'Please read and agree to the Privacy Policy',
    'pleaseAgreeToScan': 'Please read and agree to the terms on the right',
    'heavyFreight': 'Heavy Freight',
    '验证码接收方式': 'Verification code receiving method',
    'cancelTips': 'Your account has not been bound with mobile phone number or email . Please go to bind first.',
    'confirmCancel': 'Confirm',
    'verificationCodeError': 'Verification code error, please obtain the verification code again.',
    'clickGoDirectly': '(Click to go directly to)',
    'repeatTips': 'There is a duplicate problem with your account. Please go to<span class="mode">select the login method</span> and log in. It will automatically jump after {count}s.',
    'repeatTips1': 'There is a duplicate problem with your mobile phone number. Please log in after<span class="mode">selecting the area code</span> and jump automatically after {count}s.',
    'goOldLogin': 'Login of old version',
    'goNewLogin': 'Login of new version',
    'siteTips': 'For a better system experience, you can choose to switch to another country or region',
    'siteGo': 'Proceed',
    'loginLoading': 'Your account will automatically log in to the new system,please wait a moment',
    'sfExpress': 'SF Express, all rights reserved. Company Licence ICP-08034243',
    'sgSfExpress': 'SF Express, all rights reserved.',
    'kex': 'KEX',
    'iuopOsPatent': 'Copyright© ABX EXPRESS (M) SDN BHD. All Rights Reserved.	',
    'unite': 'International Central Authentication Service',
    'jumpError': 'The jump address is illegal',
    'tips': 'Tips',
    'tips1': 'Tips',
    'confirm': 'Confirm',
    'agreeWith': 'I have read and agree to the ',
    'agreeAndContinue': 'I have read and agree to the privacy policy',
    'agreeService': 'I have read and agree to the  Terms of Service',
    'agreeUserAgreement': 'I have read and agree to the User Agreement',
    'agreeEpesAcceptableUse': 'I have read and agree to the SF Korea ERP Acceptable Use Policy',
    'define': 'Confirm',
    'cancel': 'Cancel',
    'yes': 'Yes',
    'no': 'No',
    'sendAgain': 'Send again',
    'second': ' s',
    'iknow': 'I know ',
    'country': 'Country/district',
    'tel': 'Mobile No.',
    'email': 'Email',
    'telNumber': 'Mobile No.',
    'verifyCode': ' Verification code',
    'sendVerificationCode': 'Send verification code ',
    'next': 'Next ',
    'prev': 'Previous',
    'finished': 'Done',
    'back': 'Back',
    'backLogin': ' Back to login',
    'home': ' intl.sf',
    'home_os': 'KEX Express',
    'inquiry': 'Inquiry',
    'add': 'Add',
    'edit': 'Edit',
    'del': 'Delete',
    'batchDel': 'Batch delete',
    'operating': 'Operate',
    'clearInfo': 'Clear info.',
    'excelUpload': 'Upload Excel',
    'serialNumber': 'No.',
    'save': 'Save',
    'leastOne': 'Tick the data to be deleted',
    'uploadFile': 'Upload file',
    'downloadExcel': 'Download EXCEL template',
    'pleaseInput': 'Please input',
    'pleaseSelect': 'Please select',
    'isDel': 'Delete the selected data?',
    'agree': 'Agree',
    'disagree': 'Disagree',
    'uploadTotal': 'Total upload',
    'uploadSuccess': 'Upload succeeded',
    'uploadFail': 'Upload failed',
    'checkAll': 'Select all',
    'cancelContent': 'The cancellation of this account is submitted on [{cancelTime}], the account will be activated if login in 15 days. Continue to log in or not?',
    'ok': 'OK', // V1.5
    'autoTip': 'Authentication in progress, please wait...',
    'feedback': 'Function Suggestion',
    'scanCode': 'Scan code to log in',
    'useWxScan': 'Use WeChat to scan',
    'useWhatsAppScan': 'Use WhatsApp to scan',
    'otherLoginWays': 'Other login method',
    'scanSuccessfully': 'Scan code success',
    'confirmOnPhone': 'Please confirm on your mobile phone',
    'refreshQR': 'Click to refresh',
    'consult': 'Consulting',
    'please_select_correct_phone': 'Please select the correct phone area code',
    '国际标快': 'Standard Express',
    '国际特惠': 'Economy Express',
    '顺丰集运': 'SFBUY',
    '国际电商专递': 'E-Commerce Express',
    '国际小包': 'E-Parcel',
    '海外仓': 'Overseas Fulfilment/Warehouse',
    '顺丰国际产品导航': 'Product Navigation'
  },
  'channel': {
    'gls': 'Global League System',
    'gls_tooltip': 'Please fill in the login account in the body of the email, the email subject [GLS Forget password], and send the email to [wuzipeng@sf-express.com]'
  },
  'login': {
    'toLogin': 'Go log in',
    'account': 'Account',
    'accountRepeativeTitle': 'Account duplication processing',
    'accountRepeativeDesc': 'Your account has duplicates. you need to confirm which account you will use to log in to the system. You can also choose to Cancel or rebind one of the accounts after logging in to avoid similar situations in the future.',
    'accountType': 'Account type',
    'aciton': 'Operation',
    'merge': 'Three element fusion version',
    'unique': 'Three element independent version',
    'selectLoginType': 'Select login type',
    'personal': 'Personal Login',
    'enterprise': 'Enterprise Login',
    'tel': 'Mobile No.',
    'password': 'Password',
    'verificationCodeLogin': 'Login with verification code',
    'verificationCode': 'Verification code',
    'obtainVerificationCode': 'Get verification code',
    'passwordLogin': 'Login with password',
    'rememberPSD': 'Remember me',
    'rememberTips': 'Not recommended for public devices',
    'forgetPSD': 'Forgot password',
    'loginAgree': 'I have read and agree to the',
    'epesAcceptableUse': 'SF Korea ERP Acceptable Use Policy',
    'agreeTips': 'Privacy Policy',
    'userAgreement': 'User Agreement',
    'login': 'Login',
    'username': 'User Name',
    'email': 'Email',
    'phoneLogin': 'Login with mobile No.',
    'usernameLogin': 'Login with username',
    'emailLogin': 'Login with email',
    'usernameOrEmailLogin': 'Login with username or email',
    'registerNow': 'Register now',
    'pleaseInput': '',
    'and': ' and ',
    'sfbuy_privacy': '《SFBuy Service Agreement(Chinese Mainland)》、《SFBuy Service Agreement(International/HK, MO and TW of China)》',
    'sfbuy_title': 'SFBuy',
    'aboutUs': 'About us',
    'serviceGuide': 'Service guide',
    'helpCenter': 'Help center',
    'serviceAndPrice': 'Service and Price',
    'onlineCSR': 'Online CSR',
    'copyright': 'Copyright ©2023 SF Express'
  },
  'register': {
    'personal': 'Personal Registrationn',
    'enterprise': 'Enterprise  Registration',
    'tel': 'Mobile No.',
    'telVerificationCode': 'Mobile phone verification code',
    'email': 'Email',
    'emailVerificationCode': 'Email verification code',
    'sendVerificationCode': 'Send verification code',
    'password': 'Enter password',
    'passwordAgain': 'Enter password again',
    'agree': 'I have agreed on the ',
    'termsOfService': 'Terms of Service',
    'SFBuyService': 'SFBuy Service agreement',
    'and': ' & ',
    'privacyPolicy': 'Privacy Policies',
    'registerNow': 'Register now',
    'haveUserName': 'Have an account already?',
    'loginNow': 'Login now',
    'toEmail': ' Email registration',
    'toTel': ' Phone registration',
    'invitationCode': 'Invitation code',
    'timeCount': '（{count}s remaining, please read to the end）',
    'readBottom': '（Please read to the end）',
    'isFinshRead': 'Please read and agree to the terms and conditions',
    sfbuy_policy1: '《SFBuy Service Agreement(Chinese Mainland)	》',
    sfbuy_policy2: '《SFBuy Service Agreement(International/HK, MO and TW of China)	》'
  },
  'resetPassword': {
    'resetTel': 'Reset via mobile',
    'resetEmail': 'Reset via email',
    'tel': 'Mobile No.',
    'telVerificationCode': 'Mobile phone verification code',
    'email': 'Email',
    'emailVerificationCode': 'Email verification code',
    'sendVerificationCode': 'Send verification code',
    'newPassword': 'New password',
    'confirmNewPassword': 'Confirm new password',
    'resetPassword': 'Reset password',
    'back': 'Back',
    'login': 'Login',
    'register': 'Register',
  },
  'modifyPassword': {
    'changePassword': 'Revise password',
    'old': 'Old password',
    'new': 'New password',
    'confirm': 'Confirm new password',
  },
  'cookies': {
    // v1.4.sp4开始
    'tip1': 'Our website uses cookies to optimise user experience and analytics.  We may share your information with our analytics partners. Our',
    'tip2': 'cookie policy',
    'tip3': 'has more information.  Change your settings',
    'tip4': 'here',
    'tip5': 'By clicking ACCEPT you consent to our use of cookies in accordance with your preferences.',
    'disAgree': 'Reject',
    'cookieSet': 'Cookie Setting',
    'preference': 'Preference',
    'optimisation': 'Optimisation',
    'analytics': 'Analytics',
    'neddCheck': 'You must agree preference first',
    // v1.4.sp4结束
    'cookie': 'Cookie Policy',
    'agree': 'Agree',
    'preferenceCenter': 'Preference center', // V1.6
  },
  'slideCircus': {
    'title': 'Please complete puzzle verification below',
    'change': 'Change',
    'right': 'Please slide rightward',
    'pass': 'Verification passed',
    'verifyText': 'Please click the button for verification',
    'verifying': 'Puzzle verifying…',
    'loading': ' Photo loading',
  },
  'message': {
    'slideError': 'Slider service request failed',
    'selectTerms': 'Please check and tick information of terms ',
    'verifyPass': 'Please click the button for verification',
    'registerSuccess': 'Registered successfully',
    'sendTips0': 'Sent successfully',
    'resetPasswordTips0': 'Password reset successfully',
    'loginTips0': 'Logged on successfully',
    'loginTips1': 'Log in successfully, the account is activated',
    'modifiedTips0': 'Revised successfully',
    'switchLanguage': 'Language switched successfully',
    'switchSite': 'Country switched successfully',
    'changeTel': 'Congratulations. Your mobile No. is revised successfully. Please log on again!',
    'ChangeEmail': 'Congratulations. Your phone No. is revised successfully. Please log on again!',
    'cancelSuccess': 'Congratulations, your account has been cancelled successfully!',
    'imgType': 'Please select photo again, only formats of JPG and PNG are supported for upload!',
    'imgSize': 'Please select photo again, the photo size shall not exceed 3MB!',
    'sumbitSuccess': 'Submit successfully',
    'setSuccess': 'Set up successfully ',
    'delSuccess': 'Delete successfully ',
    'addSuccess': 'Add succeeded',
    'fileType': 'Select file again, only formats of xls and xlsx supported!',
    'fileSize': 'Select file again, file size shall not exceed 15MB!',
    'delError': 'Delete failed, try again later',
    'uploadFile': 'Upload file',
    'uploadFileSuccess': 'Upload succeeded',
    'selectedOne': 'Fill in at least either clearance materials or birthday',
    'imgTips1': 'Upload photo of {imgType}format',
    'imgTips2': 'Single photo shall not exceed 3MB',
    'imgTips3': 'Single photo shall not exceed 10MB',
    'imgTips4': 'PDF file preview not supported',
    'checkProduct': 'Select product',
    'clauseAgree': 'Please agree on E-waybill Terms and Conditions',
    'estimatedCost': 'Input estimated costs in the value-added service sheet',
    'cardCode': 'Please input card No. for COD in the value-added service sheet',
    'threeTips': 'The article information is incomplete, please check again',
    'fourTips': 'Incomplete order placement information, check again',
    'noNeedUpload': 'No need to upload certificate',
    'phoneOrFixAtLeastOne': 'Fill in either mobile No. or fixed phone No.',
    'customerOrderNo': 'Please enter the order No.', // V1.5
    'mas_003038': 'An error occurred with your account number, please refresh the page and try to place international shipment order.',
    'mas_003038_HTM': 'An error occurred with your login (mobile phone number) , please refresh the page and tryto place international shipment order.',
    'mas_003035': ' If you have already registered, please  log in IUOP directly to place international shipment order.',
    'mas_auth_failed': 'Authentication failed',
  },
  'verify': {
    'selectAreaCode': 'Please choose country or district code',
    'telTips': 'Please enter Mobile No.',
    'telError': 'Please enter the correct mobile No.',
    'companyNameTrue': 'Please enter correct company name',
    'fixMobileCode': 'Please select district code of fixed phone',
    'fixMobileNumber': 'Please enter fixed phone No.',
    'fixMobileNumberReg': 'Please enter correct fixed phone No.',
    'mobileVerificationCode': 'Please enter the security code received on your phone',
    'emailAddress': 'Please enter email',
    'emailTips': 'Please enter correct email',
    'emailVerificationCode': 'Please enter verification code of email',
    'password': 'Please enter password',
    'passwordError': 'The password is 8-20 digits, and only supports three or more combinations of uppercase and lowercase letters, numbers and symbols',
    'passwordAgain': 'Please enter password again',
    'passwordNotSame': 'The entered passwords are inconsistent. Please enter again',
    'usernameTips': 'Please enter user name',
    'usernameEmailTips': 'Please enter username/email',
    'telEmailTips': 'Please enter mobile No./email',
    'fixTelEmailTips': 'Please enter the correct mobile No./email',
    'selectTerms': 'Please check and tick the terms',
    'accountName': 'It only supports 6-20 characters starting with a letter and juest can contain letters, numbers and underscores',
    'verifyType': 'Please select verification mode',
    'verifyCode': 'Please enter verification code',
    'lastNameRequired': 'The last name cannot be null',
    'firstNameRequired': 'The first name cannot be null',
    'genderRequired': 'The gender cannot be null',
    'birthdayRequired': ' The birthday cannot be null',
    'certTypeRequired': 'The certificate type cannot be null',
    'certNoRequired': ' The certificate No. cannot be null',
    'certExpireDateRequired': 'The validity of the certificate cannot be null',
    'notSupTips': 'Numbers and other special characters are not supported',
    'certImage': 'Please upload the certificate photo before submitting',
    'commodityName': 'Please input consignment name',
    'quantity': 'Input quantity',
    'unit': 'Input unit',
    'unitPrice': 'Input unit price',
    'placeOfOrigin': 'Select origin',
    'over0': 'Input No. larger than 0',
    'decimal3': 'Only 3 digits after decimal point supported',
    'decimal6': 'Only 6 digits after decimal point supported',
    'decimal10': 'Only 10 digits after decimal point supported',
    'productRecordNo': 'Input correct National Inspection Record No.',
    'hsCode': 'Input correct HS code',
    'productCustomsNo': 'Input correct EORI No.',
    'contact': 'Input name',
    'companyName': 'Input company name',
    'country': 'Select country/area',
    'regionFirst': 'Select province & city',
    'roadName': 'Input road name',
    'buildingNumber': 'Input building No.',
    'addressDetail': 'Input detailed address',
    'addressDetailTrue': 'Please enter correct detailed address',
    'postalCode': 'Input postal code',
    'phoneNumber': 'Input mobile No.',
    'numberDecimal': 'Input numbers',
    'bangmecho': 'Input district/street/No.',
    'shippingType': 'Select shipping mode',
    'clearanceInfo': 'Select certificate type',
    'idNumber': 'Input certificate No.',
    'idNumberIsTrue': 'Input correct certificate No.',
    'contactCn': 'Input correct Chinese name',
    'receiveType': 'Select certificate type',
    'imgNumber': 'At least upload {number}photo(s)',
    'papersTime': 'Select valid time of certificate',
    'declaredCurrency': 'Select currency',
    'requred': 'Required field',
    'parcelTotalWeight': 'Input total weight',
    'contentMaxLength18': '18 integers and 6 decimals supported at maximum',
    'contentIntOrFloatMaxLength': '12 integers and 10 decimals supported at maximum',
    'atLeastSelectTip': 'At least select 1 record',
    'invitationCode': 'Please enter the correct invitation code',
    'characterLength': 'No longer than {length} character',
    'pickUpTime': 'Select appointed to-door pickup time',
    'onlyNumberAndLetter': 'Only combination of numbers and letters supported',
    'serviceFee': '12 integers and 2 decimals supported at maximum',
    'methoedCode': 'Only 20 numbers supported at maximum',
    'contentInt14OrFloat2MaxLength': '14 integers and 2 decimals supported at maximum',
    'contentInt10OrFloat6MaxLength': '10 integers and 6 decimals supported at maximum',
    'contentInt18OrFloat6MaxLength': '18 integers and 6 decimals supported at maximum',
    'timeZoneCode': 'Select time zone',
    'contentInt14OrFloat1MaxLength': '14 integers and 1 decimal supported at maximum',
    'contentInt15OrFloat5MaxLength': '15 integers and 5 decimal supported at maximum',
  },
  'placeholder': {
    'countryCode': 'Please choose country or district code',
    'telCode': 'District code',
    'phoneCode': 'Please enter mobile No.',
    'mobileVerificationCode': 'Please enter the security code received on your phone',
    'verificationCode': 'Please enter Verification Code',
    'emailAddress': 'Please enter email',
    'emailVerificationCode': 'Please verification code of email',
    'password': 'Please enter password',
    'checkPassword': 'Please enter password again',
    'enter': 'Please enter',
    'username': 'Username can be used for logon',
    'cardType': 'Please select certificate type',
    'uploadCard': 'Shall be consistent with the certificate information',
    'uploadCardId': 'Please enter valid certificate No. ',
    'passwordError': 'The password is 8-20 digits, and only supports two or more combinations of uppercase and lowercase letters, numbers and symbols',
    'passwordAgain': 'Enter new password again',
    'verifyType': 'Please select verification mode',
    'newEmail': 'Please select your frequently-used email',
    'addressBook': 'Input name/company name for inquiry',
    'goodsWarehouse': 'Input consignment name/HS code for inquiry',
    'clearanceWaybill': 'Input 12-digit waybill No. or 15-digit waybill No. started with SF',
    'parcelTotalLength': 'Input length',
    'parcelTotalWidth': 'Input width',
    'parcelTotalHeight': 'Input height',
    'senderReason': 'Select shipping reason',
    'tradeCondition': 'Select trade conditions',
    'senderReasonContent': 'Fill in non-commercial shipping reason',
    'businessRemark': 'Fill in remarks for the commercial invoice',
    'pickupAppointTime': 'Select date and time (the pickup time shall be in 3 hours upon appointment)',
    'remarkText': 'Input texts manually',
    'payMethod': 'Select payment mode',
    'payMonthCard': 'Input credit account',
    'taxPayMethod': 'Input tax payment mode',
    'taxPayMonthCard': 'Input tax settlement account',
    'serviceFee': 'Input estimated fees',
    'feeCard': 'Input COD card No.',
    'invitationCode': 'Please enter the registration/VIP invitation code',
    'willBay': 'Input waybill No.',
    'senderCountry': 'Select origin',
    'receiverCountry': 'Select destination',
    'receiverContact': 'Input receiver name',
    'orderStatus': 'Select order status',
    'startTime': 'Start date',
    'to': 'To',
    'endTime': 'End date',
    'timeZoneCode': 'Select time zone',
  },
  'tagsView': {
    'refresh': 'Refresh',
    'close': 'Close',
    'closeOthers': 'Close others',
    'closeAll': 'Close all',
  },
  'exit': {
    'title': 'logout',
    'message': 'Confirm to exit？',
    'success': 'Exit successfully!',
    'cancel': 'Cancel exit!',
    'close': 'Cancel successfully',
  },
  'notFind': {
    'oops': '404',
    'info': 'Sorry, the page you visit does not exit',
    'backHome': 'Go Home',
  },
  'settings': {
    'title': 'Unified user center of SF International',
  },
  'role': {
    'admin': 'Administrator',
    'user': 'Common user',
  },
  'route': {
    'Login': 'Login',
    'Register': 'Register',
    'ResetPassword': 'Find password',
    'UserCenter': 'Profile',
    '顺丰国际产品导航': 'Product Navigation',
    'MyInfomation': ' My information ',
    'AccountInfomation': 'Account information',
    'BaseInfomation': 'Basic information',
    'AccountSecurity': 'Account security',
    'ProtocolManage': 'Sign management',
    'BindingEmail': 'Bind with email',
    'BindingPhone': 'Bind with phone',
    'AccountSetting': 'Account Settings',
    'CancelAccount': 'Cancel account',
    'ChangeEmail': 'Revise email',
    'ChangePassword': 'Change password',
    'ChangePhone': 'Change phone No.',
    'Name': 'Set Username',
    'ToMail': 'Shipping',
    'MailProduct': 'Shipping products',
    'AddressBook': 'Address book',
    'GoodsWarehouse': 'Goods warehouse',
    'Order': 'Order management',
    'OrderIndex': 'Order list',
    'OrderAdd': 'Single shipment order',
    'Clearance': 'Clearance materials',
    'UploadPhotoid': 'Upload certificate',
    'EditOrder': 'Order editing',
    'permission': '权限管理', // v1.2
    'permission_system': '系统管理', // v1.2
    'permission_role': '角色管理', // v1.2
    'permission_resource': '资源权限', // v1.2
    'permission_user': '用户管理', // v1.2
  },
  'button': {
    'sumbit': 'Submit',
  },
  'accountInfo': {
    'username': 'Username：',
    'firstname': 'Name：',
    'lastname': 'Last name:',
    'sex': 'Gender:',
    'man': 'Male',
    'woman': 'Femal',
    'telNumber': 'Mobile No.: ',
    'telNumberNot': 'Your account has not bound with Mobile No.',
    'email': ' Email:',
    'emailNot': ' Your account has not bound with the email',
    'binding': 'Bind immediately> ',
    'changeTel': 'Change mobile No. > ',
    'changeEmail': 'Revise email > ',
    'validated': 'Verified',
    'autoGeneration': 'Automatically generated',
    'usernameTips': 'The username cannot be changed after setup',
    'birthday': 'Birthday：',
    'birthday1': 'Birthday', // v1.4
    'autoCreate': 'Automatically generated',
  },
  'baseInfo': {
    'cardType': 'Certificate type：',
    'firstname': 'Name:',
    'lastname': 'Last name:',
    'cardId': 'Certificate No.:',
    'cardTime': 'Certificate validity:',
    'cardImg': ' Certificate photo:',
    'cardLangTime': 'Valid permanently ',
    'uploadImg': 'Upload photo',
    'titleTips': 'Warm tip: Real name is required by the country for sending the shipments for customs clearance, the certificate information will be stamped with customs clearance exclusive seal. SF will guarantee your information security. ',
    'dialogTitle': 'Standard example',
    'dialogTips': 'The certificate photo shall be complete and the text shall be clear without reflection of light and shielding. If it is too dim, the verification will fail!',
    'cardUp': ' Front side of certificate card',
    'cardDown': 'Back side of certificate card ',
  },
  'emailLink': {
    'tips': ' Please set account password',
    'setPassword': 'Set password',
    'success': 'Account activates successfully',
  },
  'accountSecurity': {
    'ChangePassword': 'Change password',
    'ChangePasswordDesc': 'If password is forgotten because you have not logged on for a long time, you can revise the password after identity verification. ',
    'BindingPhone': 'Binding phone',
    'BindingPhoneDesc': 'The bound mobile No. can be used for login, retrieve password, order placement and other services. ',
    'BindingEmail': 'Binding email',
    'BindingEmailDesc': 'The bound email can be used for login, retrieve password, order placement and other services. ',
    // V1.2开始
    'SettingName': 'Set Username',
    'SettingNameDesc': 'The Username can be used as the logon account and cannot be revised after setup',
    'immediatelySet': 'Set up now',
    'alreadySet': 'Set',
    'settingComplete': 'Setup completed',
    'alreadyBinding': 'Bound',
    'SettingRealName': 'Set First name&Last name	',
    'firstname': 'first name',
    'lastname': 'last name',
    'SettingRealNameDesc': 'Set personal name information as an account attribute that can be edited multiple times.',
    'userName': 'Username',
    'userNameLogin': 'Username can be used for logon',
    'selfCreate': 'Automatically generated',
    'stopEdit': 'The Username cannot be revised after setup',
    'setOk': 'Setup completed',
    // V1.2结束
    //  V1.3.SP3 账号注销开始
    'cancelAccount': 'Account cancellation',
    'cancelAccountTips': 'Be cautious, the data cannot be restored after cancellation',
    'toCancel': 'Cancel now',
    'cancelToKnow': 'Account cancellation agreement',
    'cancelDesc1': '1. This account is a unified account of SF International. Once it is canceled on platforms related to SF International, the account canceled cannot be used and restored on SF International\'s platforms. Please be cautious, please back up all the information and data before the operation;',
    'cancelDesc2': '2. Applying for cancellation means you voluntarily give up all the membership privileges and virtual assets (including but not limited to membership reward points, membership level and privileges, coupons and so on);',
    'cancelDesc3': '3. After cancellation, you cannot log in and use this account and find any contents or information related to this account, including but not limited to user name and icons (the waybill information will be saved based on the time limit agreed by the privacy policies, you can check the route information with the waybill No. on SF\'s official website);',
    'cancelDesc4': '4. If you have activated the credit card account, after cancellation, the binding relation of this account and your credit account will be unbound; if you need to continue to use the credit account, you need to bind with a new account;',
    'cancelDesc5': '5. Cancellation of this account does not waive or mitigate related liabilities of behaviors before the cancellation of the account;',
    'cancelDesc6': '6. This cancellation application can be canceled in 15 days, the user can cancel the account cancellation application within 15 days after the cancellation.',
    'cancelAgree': 'I have read and agree to the "Account Cancellation Agreement"',
    'cancelTitle': 'Cancel account',
    'cancelConfirm': 'Confirm to cancel the account now?',
    'cancelTips': 'Please read and agree on the account cancellation agreement',
    //  V1.3.SP3 账号注销结束
    'goBinding': 'Bind now',
    'changeBinding': 'Change the binding immediately',
    'auth': 'Identity authentication',
    'finish': 'Revise completed',
    'binding': 'Binding completed',
    'verifyType': 'Verification mode',
    'ChangePhone': 'Change phone',
    'ChangeEmail': 'Change email',
    'tips1': 'Congratulations. Your password is changed successfully',
    'tips2': 'Congratulations. Your mobile No. is changed successfully',
    'tips3': 'Congratulations. Your email is changed successfully ',
    'tips4': 'Congratulations. Your mobile No. is bound successfully',
    'tips5': ' Congratulations. Your email is bound successfully ',
    'tips6': 'Congratulations, Username successfully set up',
    pleaseFirst: 'Please go first',
    or: 'or'
  },
  'accountConflict': {
    'title': 'Account Confirmation',
    'desc1': 'Dear customer,',
    'desc2': 'The system has detected that your Email/mobile phone has been registered in multiple systems of our company. </br>In order to improve your experience, please select one of your login accounts as the unified login account of multiple systems. ',
    'desc3': 'After clicking "Confirm", the system will send you a Email or SMS to you to reset your password. Please follow the prompts and keep it properly.',
    'loginName': 'Login name',
    'phone': 'Mobile No.',
    'registerSys': 'Registration system',
    'registerTime': 'Registration time',
    'newRegister': 'A new registration',
    'infoVer': 'Verify info',
    'inforVerSelect': 'Please select your verification method',
    'selectOne': 'Please select one of your login accounts',
    'IBS': 'Order and Shipment Management System',
    'ICAS': 'International Customer Account System',
    'IUOP': 'International Unified Order Platform',
    'IBSE': 'International Business System Export',
    'PMS': 'International Business System Import',
    'IBSI': 'International Business System Import',
    'SFBUY': 'SFBUY',
    'POP': 'Partner Open Platform',
    'SFGOAPP': 'SF GO',
    'IFTP': 'International Freight Transportation Platform',
    'OFTP': 'Overseas Freight Transportation Platform'
  },
  permission: {
    reset: 'Reset',
    enable: 'Enable',
    disable: 'Disable',
    delete: 'Delete',
    deleteBatch: 'Delete by batch',
    remark: 'Remarks',
    sort: 'Sorting',
    confirm: 'OK',
    cancel: 'Cancel',
    operation: 'Operate',
    modify: 'Revise',
    select: 'Please select',
    input: 'Please enter User ID or Username',
    query: 'Query',
    edit: 'Edit',
    required_rule: 'The data cannot be null',
    success: 'Operation succeeded',
    fail: 'Operation failed',
    length_rule: 'The length is from {min} to {max} characters',
    deleteTip1: 'Please disable all the sub-systems under"{name}"first',
    deleteTis: 'Are you sure to delete the data item with the name of"{name}"?',
    deleteChildTis: 'All the systems under the system will be deleted at the same time',
    tis: 'Prompt',
    deleteBatchTis: 'Are you sure to delete the selected {num} pieces of data?',
    enableTis: 'Are you sure to enable/disable the selected {num} pieces of data with the name of{statusName}?',
    msgError: 'Wrong operation',
    codeCheckRule: 'Capital and lower-case letters, numbers, "_"or"-"',
    checkMinCharacter: 'Please enter more than {min} characters',

    // Role management
    roleType_0: 'Self-established role',
    roleType_1: 'System administrator',
    bindResource: 'Bind with resources',
    roleList: 'Role list',
    roleAdd: 'Add role',
    roleEdit: 'Edit role',
    roleConfig: 'Configure role',
    childSystemName: 'Sub-system name',
    roleNo: 'Role No.',
    roleName: 'Role name',
    roleDescribe: 'Role description',
    isSystem: 'Subordinate system',
    roleType: 'Role type',

    // User management
    userStatus_0: 'Not activate',
    userStatus_1: 'Activated',
    userStatus_2: 'Pre-cancelled',
    userStatus_3: 'Cancelled',
    userStatus_4: 'Disabled',
    userStatus_5: 'Lock',
    userRoleEdit: 'View/edit role',
    userList: 'User list',
    regtime: 'Registration time',
    userCode: 'User ID',
    area: 'Area',
    nickName: 'Nickname',
    sourceSystem: 'Source system',
    userStatus: 'Status',

    // System management
    systemList: 'System list',
    systemAdd: 'Add system',
    systemModify: 'Modify system',
    systemName: 'System name',
    systemType: 'System type',
    systemType_0: 'Master data',
    systemType_1: 'Business system',
    systemCode: 'System code',
    systemStatus: 'System status',
    systemStatus_0: 'Enable',
    systemStatus_1: 'Disable',
    systemAddChildren: 'Add sub-system',
    systemSuperior: 'Superior system',

    // Resource management
    resourceList: 'Resource list',
    resourceAdd: 'Add resource',
    resourceModify: 'Revise resource',
    resourceName: 'Resource name',
    resourceType: 'Resource type',
    resourceType_MENU: 'Menu',
    resourceType_MODULE: 'Content',
    resourceType_WIDGET: 'Button',
    resourceCode: 'Resource code',
    resourceStatus: 'Resource status',
    resourceStatus_true: 'Enable',
    resourceStatus_false: 'Disable',
    resourceAddChildren: 'Add sub-item',
    resourceSuperior: 'Superior menu',
    icon: 'Icon style',
    iconActive: 'Active icon',
    shortName: 'Short name',
    resourceUrl: 'Resource URL',
    resourceFun: 'Function URL',
    openType: 'Open mode',
    openType_0: 'Page route',
    openType_1: 'New window',
    pub: 'Is permission control required',
    pub_true: 'Yes',
    pub_false: 'No',
    hidden: 'Hide or not',
    hidden_0: 'Yes',
    hidden_1: 'No',
    selectSystem: 'Please select system',
  },
  protocol: {
    num: 'Number',
    protocolName: 'Agreement name',
    protocolNo: 'Protocol version number',
    signTime: 'igning time',
    remark: 'Remarks',
    signUser: 'Signing account number',
    signName: 'Signed customer name',
    signChild: 'Protocol version number of child',
  },
  sfbuy: {
    'wechatScane': 'Scan with WeChat',
    'wechatScane1': 'real-time',
    'wechatScane2': 'parcel tracking',
    'onlineService': 'Online CSR',
    'aboutUs': 'About us',
    'serviceGuide': 'Service guide',
    'helpCenter': 'Help center',
    'serviceAndPrice': 'Service and Price',
    'announcement': 'Announcement',
    'important': 'Important'
  },
  messageNotice: {
    'yxDetail': 'details',
    'optional': 'optional',
    'loginXyAgree': 'I agree to receive marketing and advertising notifications',
    messageNotice: 'Message Notifications',
    messageNoticeDesc: 'Supports notification configuration',
    messageNoticeBtn: 'Configuration',
    messageNoticeTitle: 'Marketing Notification Settings',
    messageNoticeTitleDesc1: 'Refer to ',
    messageNoticeTitleDesc2: 'for personal info collection. Checkbox indicates consent for marketing ads',
    messageNoticeDetailTitle: 'Marketing Notification Data Details',
    message: 'SMS',
    messageNotcieDialogTitle: 'Marketing Channel Configuration',
    considerLater: 'Consider later',
    messageNotcieDialogDesc1:
    'Clicking the confirm button means you agree to us sending you marketing and advertisements that may interest you through the following channels. For details on personal information collection, please refer to the ',
    messageNotcieDialogDesc2: '.',
    messageNotcieDialogDetail: 'details',
  },
  weakPassword: {
    提示: 'Tips',
    账号异常提醒: 'Your account has unusual activity. Please reset your password or log in via verification code/QR code.',
    修改密码: 'Reset Password',
    关闭: 'Close',
    账号异常处理: 'Account Anomaly Handling',
    绑定提示: 'Please bind your phone or email first, then reset your password',
    账号: 'Account'
  },
  recommendedPassword: {
    使用推荐密码: 'Use recommended password',
    提示: 'Note',
    请保管好您的密码: 'Please keep your password safe. We recommend changing it promptly after logging in.',
    复制密码: 'Copy Password',
    psd: 'Password',
    copySuccess: 'Copy successfully',
    注册成功: 'Congratulations on successful registration!',
    注册建议: `To ensure account security, it is recommended that you go to "Management Center - Account Settings" to change your password.`,
    修改密码: ''
  },
  twoFactorAuth: {
    双因素认证: 'Two-factor authentication',
    认证方式: 'Authentication method',
    为了您的账号安全: 'For the security of your account, please complete two-factor authentication before logging in.',
    请选择绑定: 'Please select binding:',
    请先设置您的密码: 'Please set your password first'
  },

  sendType: {
    您当前手机区号不支持whatsapp: 'Your current mobile area code does not support {noticeChanel}, please choose another method to get the verification code',
    请使用绑定手机号接收验证码: 'Please use your registered phone number to receive the verification code',
    请使用绑定邮箱接收验证码: 'Please use your registered email to receive the verification code',
    请选择验证码接收方式: 'Please select the method to receive the verification code'
  },
  recommendFloat: {
    '满意度评价': 'Satisfaction Evaluation',
    '您的评价对我们很重要': 'Your feedback is very important to us',
    '我要评价': 'I want to give feedback'
  }
}
